<template>
  <div>
    <h1>this is admin dashboard</h1>
  </div>
</template>
